import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Manifesto from "@/components/site/Manifesto";
import Founder from "@/components/site/Founder";
import CaseStudy from "@/components/site/CaseStudy";
import HowItWorks from "@/components/site/HowItWorks";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import useTracking from "@/components/site/useTracking";
import Analytics from "@/pages/Analytics";

function SiteHome() {
  useTracking();
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App relative">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Founder />
        <CaseStudy />
        <HowItWorks />
        <Booking />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SiteHome />} />
          <Route path="/analytics" element={<Analytics />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
